export const LOGIN = "LOGIN";
export const REQ_USER = "REQ_USER";
export const LOGOUT = "LOGOUT";
export const INSERT_AUDITSTAMPING = "INSERT_AUDITSTAMPING";
export const UPDATE_AUDITSTAMPING = "UPDATE_AUDITSTAMPING";
export const AUDITSTAMPING_LIST = "AUDITSTAMPING_LIST";
